import { PersonaEditor } from "@/components/persona-editor";
import Head from "expo-router/head";
import { Fragment } from "react";

export default function PersonaIndex() {
  return (
    <Fragment>
      <Head>
        <title>Personas - Lexikon AI</title>
      </Head>
      <PersonaEditor />
    </Fragment>
  );
}
